import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  ListGroup,
  Carousel,
} from "react-bootstrap";
import {
  CheckCircleFill,
  Download,
} from "react-bootstrap-icons";
import {
  PeopleFill,
  CashStack,
  Truck,
  HouseDoorFill,
  BarChartFill,
  CalendarCheckFill,
  FileEarmarkTextFill,
  ClipboardCheckFill,
  JournalBookmarkFill,
  GearFill,
} from "react-bootstrap-icons";
import DemoCall from "./DemoCall";
import BookDemo from "./BookDemo";
import SEO from "./SEO";

function SchoolErpDetails() {
   const [show, setShow] = useState(false);
  
    const [selectedProduct, setSelectedProduct] = useState("");
    
      const openDemo = (product) => {
       setSelectedProduct(product);
       setShow(true);
     };

  return (
    <div style={{ background: "#f4f7fb" }}>
      <SEO
  title="Best School ERP Software in Pune | Complete School Management System | Uiplus Technologies"
  description="Uiplus School ERP Software helps schools manage admissions, student records, attendance, fees, exams, transport, hostel and accounting with a secure cloud-based system."
  keywords="School ERP Software in Pune, School Management System India, Student Management Software, School Automation Software, Best School ERP India"
  url="https://uiplus.in/products/school-management"
/>
      {/* HERO SECTION */}
      <div
        style={{
          background: "linear-gradient(135deg, #0d6efd, #6610f2)",
          color: "white",
          padding: "70px 0",
          textAlign: "center",
        }}
      >
        <h1 className="fw-bold">Uiplus School ERP Application</h1>
        <p>Smart • Secure • Powerful • Modern School Automation</p>
      </div>

      <Container className="py-5">

        {/* IMAGE SLIDER */}
        <Row className="mb-5">
          <Col>
            <div className="slider-wrapper">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/sch-erp-details.png"
                    alt="Dashboard"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/sch-school-dashboard.png"
                    alt="Reports"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/sch-Admission-Data.png"
                    alt="Attendance"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/sch-Account-ledger.png"
                    alt="Attendance"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/sch-classwise-promote.png"
                    alt="Attendance"
                  />
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>
        </Row>

        {/* ABOUT */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3">About Uiplus School ERP</h3>
            <p style={{ textAlign:"justify" }}>
              A complete integrated School Management System designed to
              automate administrative, academic and financial operations.
              Manage student records, attendance, exams, fee Collection,
              accounting, transport, hostel and reporting — all in one platform.
            </p>
          </Col>
        </Row>

        {/* MODULES SECTION */}
<h3 className="fw-bold mb-5 text-center">Modules & Features</h3>

<Row className="g-4 mb-5">

  {[
    {
      title: "Student Module",
      description:
        "Manage enquiry, admission, enrolment, promotion, bonafide, certificates and student reports.",
      icon: <PeopleFill />,
      color: "gradient-blue",
    },
    {
      title: "Fee Structure & Collection",
      description:
        "Fee setup, discounts, receipts, due statements and automated reminders.",
      icon: <CashStack />,
      color: "gradient-green",
    },
    {
      title: "Transport Management",
      description:
        "Route, vehicle assignment, transport fees and due reports.",
      icon: <Truck />,
      color: "gradient-orange",
    },
    {
      title: "Hostel Management",
      description:
        "Hostel allocation, fee collection, occupancy and hostel reports.",
      icon: <HouseDoorFill />,
      color: "gradient-purple",
    },
    {
      title: "Accounting & Finance",
      description:
        "Bank ledger, daybook, trial balance, income & expense reports.",
      icon: <BarChartFill />,
      color: "gradient-red",
    },
    {
      title: "Attendance Management",
      description:
        "Daily/monthly attendance with dashboard summary.",
      icon: <CalendarCheckFill />,
      color: "gradient-cyan",
    },
    {
      title: "Examination System",
      description:
        "Timetable, hall ticket, marks entry and auto result calculation.",
      icon: <FileEarmarkTextFill />,
      color: "gradient-indigo",
    },
    {
      title: "Test Module",
      description:
        "Class tests, subject tests and performance reports.",
      icon: <ClipboardCheckFill />,
      color: "gradient-teal",
    },
    {
      title: "Homework & Events",
      description:
        "Homework management, reports and event notifications.",
      icon: <JournalBookmarkFill />,
      color: "gradient-pink",
    },
    {
      title: "Master Settings & Roles",
      description:
        "Academic year setup, class master, role & permission control.",
      icon: <GearFill />,
      color: "gradient-dark",
    },
  ].map((module, index) => (
    <Col md={6} lg={4} key={index}>
      <Card className="module-card h-100 border-0 rounded-4">
        <Card.Body>

          <div className={`module-icon ${module.color}`}>
            {React.cloneElement(module.icon, { size: 28, color: "#fff" })}
          </div>

          <h5 className="fw-bold mt-3">{module.title}</h5>

          <p className="text-muted">{module.description}</p>

        </Card.Body>
      </Card>
    </Col>
  ))}

</Row>



        {/* KEY BENEFITS */}
        <h3 className="fw-bold mb-4 text-center">Key Benefits</h3>

        <Row className="mb-5">
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Automation of daily administrative tasks
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Accurate fee & finance reporting
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Real-time management dashboard
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Error-free exam result calculation
              </ListGroup.Item>
            </ListGroup>
          </Col>

          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Parent & Student Mobile App Access
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Transport & Hostel Monitoring
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Multi-user role-based permissions
              </ListGroup.Item>
              <ListGroup.Item>
                <CheckCircleFill className="text-success me-2" />
                Reduces Manual Work by 80%
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        {/* WHY CHOOSE */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3 text-center">
              Why Choose Uiplus School ERP?
            </h3>
            <p className="text-center">
              100% Cloud or Local Installation • Fast & Secure • Customizable Reports • 
              Works on Mobile, Tablet & Desktop • Enhances Parent–School Communication
            </p>
          </Col>
        </Row>

        {/* CTA BUTTONS */}
        <Row className="text-center">
          <Col className="md={4}"></Col>
          <Col className="md={2}">
            <Button
              variant="primary"
              className="rounded-pill px-4"
              onClick={() => openDemo("School ERP Application")}
            >
              Book Live Demo
            </Button>

          </Col>
          <Col className="md={2}">
           
            <Button
              variant="outline-primary"
              className="rounded-pill px-4"
              href="/images/Uiplus-School-ERP-Broucher.pdf"
              download
            >
              <Download className="me-2" />
              Download Brochure
            </Button>
          </Col>
          <Col className="md={4}"></Col>
        </Row>

      </Container>

      <DemoCall />

      <BookDemo
          show={show}
          handleClose={() => setShow(false)}
          productName={selectedProduct}
        />

    </div>
  );
}

export default SchoolErpDetails;

